export const iconFontAwesomeMedicalHealthSuitcaseMedical = (
	<i className="fa-solid fa-suitcase-medical"></i>
);
